import { useSideSheetState } from '@bechtel/gds';
import { useLocation, useNavigate, useParams } from 'react-router';
import { ErrorBoundary } from '~/components';
import { CreateReservationSideSheet } from './slide-sheet';
import { CreateReservationProps } from './type';

export const CreateReservation: React.FC<CreateReservationProps> = ({ draftToolOrder, onClose: onCLoseParent }) => {
  const { close, visible } = useSideSheetState(true);
  const { toolRoomId } = useParams();
  const location = useLocation();
  draftToolOrder = !draftToolOrder ? location.state?.draftToolOrder : draftToolOrder;
  const draftToolRoomId = draftToolOrder?.toolRoomId;
  const navigate = useNavigate();

  const onClose = () => {
    close();
    navigate('/reservations');
    if (onCLoseParent) {
      onCLoseParent();
    }
  };
  if (!toolRoomId && !draftToolOrder) return <></>;
  return (
    <ErrorBoundary>
      <CreateReservationSideSheet
        onClose={onClose}
        toolRoomId={draftToolOrder ? draftToolRoomId : toolRoomId}
        visible={visible}
        draftToolOrder={draftToolOrder}
      ></CreateReservationSideSheet>
    </ErrorBoundary>
  );
};
